import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js/max';

const phoneInput = value => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  if (!/^[+0-9().\s-]+$/.test(raw)) return null;
  if ((raw.match(/\+/g) || []).length > 1 || (raw.includes('+') && !raw.startsWith('+'))) return null;

  const digits = raw.replace(/\D/g, '');
  if (raw.startsWith('+')) return raw;
  if (digits.startsWith('55') && [12, 13].includes(digits.length)) return `+${digits}`;
  return [10, 11].includes(digits.length) ? raw : null;
};

export const normalizeAgentPhone = value => {
  const input = phoneInput(value);
  if (input === '') return '';
  if (input === null) return null;
  const phone = parsePhoneNumberFromString(input, 'BR');
  return phone?.isValid() ? phone.number : null;
};

export const formatAgentPhone = value => {
  const raw = String(value ?? '');
  // Keep bad legacy/input values visible until the operator corrects them.
  if (!raw || !/^[+0-9().\s-]+$/.test(raw)) return raw;
  if ((raw.match(/\+/g) || []).length > 1 || (raw.includes('+') && !raw.startsWith('+'))) return raw;
  const input = phoneInput(raw) ?? raw;
  return new AsYouType('BR').input(input);
};
